<template>
	<div :id="id" class="detail_day">
		<div class="inner_schedule">
			<div class="info_schedule">
				<span class="time_schedule">
					<span class="sr_only">시작시간</span>
					<span class="inner_time" v-html="iconText"></span>
				</span>
				<strong class="tit_schedule">{{ schedule.title }}</strong>
				<span class="remark_schedule">
					<span class="color_remark" :style="style"></span>
					{{ schedule.category.name }}
				</span>
			</div>
			<div class="info_schedule">
				<span class="info_ico">
					<span class="ico_cafe ico_time">시간</span>
				</span>
				<span v-html="formattedKoreanTime"></span>
			</div>
			<div class="info_schedule" v-if="schedule.timeZone && schedule.timeZone.timezoneId !== 1">
				<span class="info_ico">
					<span class="ico_cafe ico_global">해외기준시간</span>
				</span>
				{{ schedule.timeZone.name }} (GMT{{ gmt }}) 기준<br>현지시간 {{ formattedLocalTime }}
			</div>
			<div class="info_schedule" v-if="schedule.description || schedule.image">
				<span class="info_ico">
					<span class="ico_cafe ico_memo">메모</span>
				</span>
				<p class="info_description" v-if="schedule.description" v-html="description"></p>
				<a v-if="schedule.image" class="thumb_link" :href="escapeScheduleImageThumbUrl(schedule.image)" target="_blank">
					<span class="thumb_g" :style="bgImage"></span>
				</a>
			</div>
			<div class="info_schedule" v-if="schedule.location">
				<span class="info_ico">
					<span class="ico_cafe ico_location">위치</span>
				</span>
				<a :href="'//map.daum.net/?from=total&nil_suggest=btn&tab=place&q=' + schedule.location" class="link_location" target="_blank">{{ schedule.location }}</a>
			</div>
		</div>
		<div v-if="isAdmin" class="wrap_btn wrap_btn_type2">
			<button @click="deleteSchedule" type="button" class="btn_comm btn_delete">
				<span class="ico_cafe ico_delete">삭제</span>
				<span>삭제하기</span>
			</button>
			<button @click="modifySchedule" type="button" class="btn_comm btn_modify">
				<span class="ico_cafe ico_modify">수정</span>
				<span>수정하기</span>
			</button>
		</div>
	</div>
</template>

<script>
import {activateUrlAutomatically, escapeHtml, getThumbnailUrl} from '@src/utils';

import {format, parseISO, subDays} from 'date-fns';
import ko from 'date-fns/locale/ko';

import {getIconText} from '@src/schedule/common';
import axios from 'axios';
import {escapeScheduleImageThumbUrl} from '../../../utils';

const currentDate = parseISO(location.pathname.split('/')[3]);

export default {
	props: ['schedule', 'calendarId', 'isAdmin'],
	computed: {
		id: function () {
			return 'schedule-' + this.schedule.scheduleId;
		},
		description() {
			return activateUrlAutomatically(escapeHtml(this.schedule.description).replace(/\n/g, '<br>'));
		},

		iconText() {
			return getIconText(currentDate, this.schedule);
		},

		formattedKoreanTime: function () {
			const start = parseISO(this.schedule.startTime);
			const end = parseISO(this.schedule.endTime);

			const dateFormat = 'yyyy.MM.dd. eeee';
			const timeFormat = 'HH:mm';
			const fullFormat = `${dateFormat} ${timeFormat}`;
			const locale = { locale: ko };

			if (this.isInOneDay) {
				if (this.schedule.allDay) {
					return format(start, dateFormat, locale);
				}

				return `${format(start, dateFormat, locale)}<br>${format(start, timeFormat)} ~ ${format(end, timeFormat)}`;
			} else {
				if (this.schedule.allDay) {
					return `${format(start, dateFormat, locale)} ~<br>${format(subDays(end, 1), dateFormat, locale)}`;
				}

				return `${format(start, fullFormat, locale)} ~<br>${format(end, fullFormat, locale)}`;
			}
		},

		formattedLocalTime() {
			return format(parseISO(this.schedule.startLocalTime.slice(0, -6)), 'yyyy.MM.dd. eeee HH:mm', { locale: ko });
		},
		gmt() {
			return this.schedule.startLocalTime.slice(-6);
		},

		isInOneDay: function () {
			const start = parseISO(this.schedule.startTime);
			const end = parseISO(this.schedule.endTime);

			return (start.getDate() === end.getDate())
				|| (this.schedule.allDay && subDays(end, 1).getDate() === start.getDate());
		},

		style: function () {
			return {
				backgroundColor: this.schedule.category.color,
			};
		},
		bgImage: function () {
			return {
				backgroundImage: `url(${getThumbnailUrl(this.schedule.image, 640, 160, 'C')})`,
			};
		},
	},

	methods: {
                escapeScheduleImageThumbUrl,
		async deleteSchedule() {
			if (confirm('해당 스케줄을 삭제하시겠습니까?')) {
				try {
					await axios.delete(`/${CAFEAPP.GRPCODE}/schedule`, {
						data: {
							scheduleId: this.schedule.scheduleId,
							calendarId: this.calendarId,
							pushyn: confirm('다음카페앱 알림 신청자에게 스케줄 삭제 알림을 보내시겠습니까?') ? 'Y' : 'N',
						},
					});

					this.$emit('delete', this.schedule.scheduleId);
				} catch ({ response }) {
					if (response.status === 401) {
						Utils.login();
					}
				}
			}
		},

		modifySchedule() {
			location.href = `/${CAFEAPP.GRPCODE}/${CAFEAPP.FLDID}/${this.schedule.scheduleId}/_schedule_edit?calendarId=${this.calendarId}`;
		},
	},
}
</script>
